"use client";

import { useQuery } from "@tanstack/react-query";
import { req } from "@padi/lib/api";
import { Crop } from "../_types";

export interface CropDetail extends Crop {
  createdAt: string;
  description: string;
  minOrderInTon: number;
  specifications: {
    beanCount?: string;
    impurities?: string;
    harvestDate?: string;
    fermentation?: string;
    gradeStandard?: string;
    moistureContent?: string;
  };
  farmer: Crop["farmer"] & {
    portfolio: {
      contactEmail: string;
      contactPhone: string;
      whatsappLink: string;
    };
    reviewsSummary: {
      totalCount: number;
      percentiles: {
        one: number;
        two: number;
        three: number;
        four: number;
        five: number;
      };
      averageRating: number;
    };
    viewsCount: number;
  };
}

// Hook to fetch individual crop by slug
export function useCropDetail(slug: string) {
  return useQuery({
    queryKey: ["crop-detail", slug],
    queryFn: () => req<CropDetail>(`public/crop-listings/slug/${slug}`),
    enabled: !!slug,
  });
}
